import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TypeQuestionEventsEnum } from 'src/app/domain/registration/enums/type-question-events.enum';
import { CES_CONFIG_FIELDS } from '../crud-config';
import { EventsService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { PermissionService } from 'src/app/shared/permission.service';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { MatTableDataSource } from '@angular/material/table';
import { SystemTypeEnum, SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';

@Component({
  selector: 'app-events-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
})
export class EventsCESComponent implements OnInit, AfterViewInit {
  title = 'EVENTOS';
  form: FormGroup;
  config: IFieldConfig[] = CES_CONFIG_FIELDS;
  typeCes: TypeCesEnum;

  showCheckboxes = false;
  showNewQuestion = false;
  showFieldSelection = false;
  showMettingFields = false;
  showBriefingFields = false;
  customQuestions: string[] = [];
  partnersSelected: any = [];
  systemsSelected: any = [];
  customQuestionControls: { name: string; controlName: string }[] = [];
  length: any;
  dataSource: MatTableDataSource<any>;
  contactIdForMeeting: string | null = null;

  constructor(
    public dialogRef: MatDialogRef<EventsCESComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private toastService: ToastService,
    private eventsService: EventsService,
    public permissionService: PermissionService
  ) {
    this.form = this.fb.group({
      description: ['', Validators.required],
      image: [null],
      limit: [''],
      typeQuestion: [''],
      name: [''],
      instagram: [''],
      email: [''],
      telephone: [''],
      enterprise: [''],
      photo: [''],
      question: [''],
      newQuestion: [''],

      //Campos para REUNIÃO
      meetingDateTime: ['', Validators.required],
      type: ['', Validators.required],
      system: ['', Validators.required],
      linkMeeting: ['', Validators.required],
      partners: ['', Validators.required],
      partner: [''],

      //Campos para BRIEFING
      briefingCustomer: ['', Validators.required],
      briefingSystem: ['', Validators.required],
      briefingPartner: ['', Validators.required],

      // Campos para armazenar nomes para exibição
      briefingCustomerName: [''],
      briefingSystemName: [''],
      briefingPartnerName: [''],

      financial: [false],
      legal: [false],
      consultant: [false],
      partnerCheckbox: [false],
      representative: [false],
      accounting: [false],
      solutions: [false],
      plans: [false],
      dashboard: [false],
      support: [false],

      //perguntas extras (limit)
      extraQuestions: this.fb.array([])
    });

    if (data?.contactId) {
      this.contactIdForMeeting = data.contactId;
      console.log('Contact ID recebido para reunião:', this.contactIdForMeeting);
    }
  }

  public getFieldConfig(name: string): any {
    return this.config.find((c) => c.name === name);
  }

  ngOnInit(): void {
    import('../../customers/crud-index/crud-index-select.component').then(({ CustomerIndexSelectComponent }) => {
      this.getFieldConfig('briefingCustomer').component = CustomerIndexSelectComponent;
    });

    // Se o tipo de evento (typeQuestion) estiver definido no data.element,
    // definir e desabilitar o campo typeQuestion
    if (this.data?.element?.typeQuestion) {
      this.form.get('typeQuestion')?.setValue(this.data.element.typeQuestion);
      this.form.get('typeQuestion')?.disable();
      this.updateVisibility(this.data.element.typeQuestion);
    }

    if (this.data.type === TypeCesEnum.EDIT && this.data.element) {
      // Aplica patch dos campos de "event_forms"
      this.form.patchValue({
        ...this.data.element,
        type: this.data.element.type || '',
        limit: this.data.element.limit || '',
        typeQuestion: this.data.element.typeQuestion || '',
        photo: this.data.element.photo || 'assets/img/wazir/wazir-icon.svg',
      });

      // Verificar ambos os formatos de REUNIÃO (com e sem acento)
      if ((this.data.element.typeQuestion === 'REUNIAO' || this.data.element.typeQuestion === 'REUNIÃO') && this.data.element.meeting) {
        const meet = this.data.element.meeting;
        console.log('Dados da reunião recebidos:', meet);

        // Capturar o objeto do sistema completo
        if (meet.system) {
          this.systemsSelected = [{
            id: meet.system.id || '',
            name: meet.system.name || ''
          }];
        }

        // Capturar o objeto do parceiro completo
        if (meet.partner) {
          this.partnersSelected = [{
            id: meet.partner.id || '',
            name: meet.partner.name || ''
          }];
        }

        // Importante: usar patchValue para atualizar múltiplos campos de uma vez
        this.form.patchValue({
          type: meet.type,
          typeQuestion: 'REUNIÃO',
          meetingDateTime: meet.meetingDateTime,
          linkMeeting: meet.linkMeeting,
          system: meet.system?.name || '',
          partners: meet.partner?.name || ''
        });

        console.log('Meeting preenchido:', {
          type: meet.type,
          system: this.systemsSelected,
          partners: this.partnersSelected
        });

        // Forçar atualização dos valores
        setTimeout(() => {
          this.form.updateValueAndValidity();
          this.cdr.detectChanges();
          // Chamar o método específico para forçar atualização dos inputs de reunião
          this.forceUpdateMeetingInputs();
        }, 0);
      }
      if (this.data.element.customQuestions) {
        this.customQuestions = this.data.element.customQuestions.map((q: any) => q.question);
        this.customQuestionControls = this.data.element.customQuestions.map((q: any, index: number) => {
          const controlName = `custom_${index + 1}`;
          this.form.addControl(controlName, this.fb.control(q.answer || ''));
          return { name: q.question, controlName };
        });
      }
    }

    // Monitorar mudanças no typeQuestion para ajustar o formulário
    this.form.get('typeQuestion')?.valueChanges.subscribe(value => {
      this.updateVisibility(value);
      // Reset do campo limit se o tipo for BRIEFING ou REUNIÃO
      if (value === 'BRIEFING' || value === 'REUNIÃO') {
        this.form.get('limit')?.setValue('');
      }
    });

    this.form.get('limit')?.valueChanges.subscribe(() => {
      this.updateExtraQuestions();
    });

    this.form.get('question')?.valueChanges.subscribe(() => {
      this.updateExtraQuestions();
    });

    this.updateExtraQuestions();
    this.updateVisibility(this.form.get('typeQuestion')?.value);
  }

  ngAfterViewInit(): void {
    // Tratamento especial para eventos do tipo REUNIÃO
    if (this.data.type === TypeCesEnum.EDIT &&
      (this.data.element?.typeQuestion === 'REUNIAO' || this.data.element?.typeQuestion === 'REUNIÃO')) {

      // Se já temos os dados da reunião no objeto element
      if (this.data.element.meeting) {
        console.log('Processando dados da reunião no ngAfterViewInit:', this.data.element.meeting);

        // Atualizar o valor do campo type (que vem do backend)
        if (this.data.element.meeting.type !== undefined) {
          this.form.get('type')?.setValue(this.data.element.meeting.type);
          console.log('Tipo definido:', this.data.element.meeting.type);
        }

        // Capturar dados do sistema
        if (this.data.element.meeting.system) {
          this.systemsSelected = [{
            id: this.data.element.meeting.system.id,
            name: this.data.element.meeting.system.name
          }];

          // IMPORTANTE: Atualizar o valor do campo system no formulário
          this.form.get('system')?.setValue(this.data.element.meeting.system.name);
          console.log('Sistema selecionado e atualizado no formulário:', this.systemsSelected);
        }

        // Capturar dados do parceiro
        if (this.data.element.meeting.partner) {
          this.partnersSelected = [{
            id: this.data.element.meeting.partner.id,
            name: this.data.element.meeting.partner.name
          }];

          // IMPORTANTE: Atualizar o valor do campo partners no formulário
          this.form.get('partners')?.setValue(this.data.element.meeting.partner.name);
          console.log('Parceiro selecionado e atualizado no formulário:', this.partnersSelected);
        }

        // Garantir que o formulário seja atualizado
        this.form.updateValueAndValidity();
        this.cdr.detectChanges();

        // Forçar atualização dos inputs específicos
        this.forceUpdateMeetingInputs();
      }
      // Se não temos os dados da reunião, mas temos o ID do evento, buscar os dados
      else if (this.data.element.id) {
        this.eventsService.getMeetingFromEvent(this.data.element.id).subscribe({
          next: (meetingData) => {
            console.log('Dados da reunião obtidos:', meetingData);
            this.data.element.meeting = meetingData;

            // Atualizar o valor do campo type (que vem do backend)
            if (meetingData.type !== undefined) {
              this.form.get('type')?.setValue(meetingData.type);
              console.log('Tipo definido:', meetingData.type);
            }

            // Capturar dados do sistema
            if (meetingData.system) {
              this.systemsSelected = [{
                id: meetingData.system.id,
                name: meetingData.system.name
              }];

              // IMPORTANTE: Atualizar o valor do campo system no formulário
              this.form.get('system')?.setValue(meetingData.system.name);
              console.log('Sistema selecionado e atualizado no formulário:', this.systemsSelected);
            }

            // Capturar dados do parceiro
            if (meetingData.partner) {
              this.partnersSelected = [{
                id: meetingData.partner.id,
                name: meetingData.partner.name
              }];

              // IMPORTANTE: Atualizar o valor do campo partners no formulário
              this.form.get('partners')?.setValue(meetingData.partner.name);
              console.log('Parceiro selecionado e atualizado no formulário:', this.partnersSelected);
            }

            // Garantir que o formulário seja atualizado
            this.form.updateValueAndValidity();
            this.cdr.detectChanges();

            // Forçar atualização dos inputs específicos
            this.forceUpdateMeetingInputs();
          },
          error: (err) => {
            console.error('Erro ao carregar reunião:', err);
          }
        });
      }
    }

    this.cdr.detectChanges();
  }

  updateExtraQuestions(): void {
    const limitControl = this.form.get('limit');
    const questionControl = this.form.get('question');

    const limitValue = parseInt(limitControl?.value, 10) || 0;
    const questionValue = questionControl?.value;

    const extraQuestions = this.form.get('extraQuestions') as FormArray;

    while (extraQuestions.length !== 0) {
      extraQuestions.removeAt(0);
    }

    if ((questionValue === true || questionValue === 'SIM' || questionValue === 'TRUE') && limitValue > 0) {
      for (let i = 0; i < limitValue; i++) {
        extraQuestions.push(this.fb.control(''));
      }
    }

    this.cdr.detectChanges();
  }

  selectPartners(event: any) {
    if (Array.isArray(event) && event.length > 0) {
      // Filtrar apenas parceiros com IDs válidos
      this.partnersSelected = event
        .filter(partner => partner.id && this.isValidUUID(partner.id.toString()))
        .map(partner => ({
          id: partner.id.toString(),
          name: partner.name
        }));

      // Se for briefing, atualizar o valor do campo no formulário
      if (this.form.get('typeQuestion')?.value === 'BRIEFING' && this.partnersSelected.length > 0) {
        this.form.patchValue({
          briefingPartner: this.partnersSelected[0].id,
          // Adicionamos um campo oculto para armazenar o nome do parceiro para exibição
          briefingPartnerName: this.partnersSelected[0].name
        });
      }
    } else if (event && event.id && this.isValidUUID(event.id.toString())) {
      this.partnersSelected = [{ id: event.id.toString(), name: event.name }];

      // Se for briefing, atualizar o valor do campo no formulário
      if (this.form.get('typeQuestion')?.value === 'BRIEFING') {
        this.form.patchValue({
          briefingPartner: event.id.toString(),
          // Adicionamos um campo oculto para armazenar o nome do parceiro para exibição
          briefingPartnerName: event.name
        });
      }
    } else {
      this.partnersSelected = [];
    }
  }

  selectSystem(event: any) {
    if (event && event.id) {
      // Garantir que temos um UUID válido
      const systemId = event.id.toString();
      if (this.isValidUUID(systemId)) {
        this.systemsSelected = [{ id: systemId, name: event.name }];

        // Se for briefing, atualizar o valor do campo no formulário
        if (this.form.get('typeQuestion')?.value === 'BRIEFING') {
          this.form.patchValue({
            briefingSystem: systemId,
            // Adicionamos um campo oculto para armazenar o nome do sistema para exibição
            briefingSystemName: event.name
          });
        }
      } else {
        console.error('ID do sistema não é um UUID válido:', systemId);
      }
    } else {
      this.systemsSelected = [];
    }
  }

  selectBriefingCustomer(event: any) {
    if (event && event.id) {
      // Armazenar tanto o ID quanto o nome do cliente
      this.form.patchValue({
        briefingCustomer: event.id,
        // Adicionamos um campo oculto para armazenar o nome do cliente para exibição
        briefingCustomerName: event.name || event.companyName || 'Cliente selecionado'
      });
      console.log('Cliente selecionado:', event);
      console.log('Valor do formulário:', this.form.get('briefingCustomer')?.value);
    }
  }

  updateVisibility(type: string): void {
    // Default: ocultar tudo
    this.showCheckboxes = false;
    this.showNewQuestion = false;
    this.showFieldSelection = false;
    this.showMettingFields = false;
    this.showBriefingFields = false;

    // Definir a visibilidade com base no tipo
    if (type) {
      this.showCheckboxes = type === TypeQuestionEventsEnum.CREATEQUESTION || type === TypeQuestionEventsEnum.QUESTIONNAIRE || type === 'TODOS';
      this.showNewQuestion = type === TypeQuestionEventsEnum.CREATEQUESTION || type === 'TODOS';
      this.showFieldSelection = type === TypeQuestionEventsEnum.QUESTIONNAIRE || type === 'TODOS';
      this.showMettingFields = type === 'REUNIÃO';
      this.showBriefingFields = type === 'BRIEFING';

      // Quando o tipo for BRIEFING, defina o campo image como null
      if (type === 'BRIEFING') {
        this.form.get('image')?.setValue(null);
      }
    }

    // Ajustar validações com base no tipo selecionado
    this.adjustFieldsRequiredByType(type);
  }

  // Método para ajustar as validações com base no tipo de evento
  adjustFieldsRequiredByType(type: string): void {
    // Desabilitar todos os validadores de campos não usados
    if (type === 'BRIEFING') {
      // Remover validadores dos campos da Reunião
      this.form.get('meetingDateTime')?.clearValidators();
      this.form.get('type')?.clearValidators();
      this.form.get('system')?.clearValidators();
      this.form.get('linkMeeting')?.clearValidators();
      this.form.get('partners')?.clearValidators();

      // Também remover validadores para name e email que não são necessários em BRIEFING
      this.form.get('name')?.clearValidators();
      this.form.get('email')?.clearValidators();

      // Adicionar validadores dos campos do Briefing
      this.form.get('briefingCustomer')?.setValidators([Validators.required]);
      this.form.get('briefingSystem')?.setValidators([Validators.required]);
      this.form.get('briefingPartner')?.setValidators([Validators.required]);
    }
    else if (type === 'REUNIÃO') {
      // Remover validadores dos campos do Briefing
      this.form.get('briefingCustomer')?.clearValidators();
      this.form.get('briefingSystem')?.clearValidators();
      this.form.get('briefingPartner')?.clearValidators();

      // Adicionar validadores dos campos da Reunião
      this.form.get('meetingDateTime')?.setValidators([Validators.required]);
      this.form.get('type')?.setValidators([Validators.required]);
      this.form.get('system')?.setValidators([Validators.required]);
      this.form.get('linkMeeting')?.setValidators([Validators.required]);
      this.form.get('partners')?.setValidators([Validators.required]);
    }
    else {
      // Para outros tipos (TODOS, FORMULARIO, QUESTIONARIO), remover validadores dos campos específicos
      this.form.get('briefingCustomer')?.clearValidators();
      this.form.get('briefingSystem')?.clearValidators();
      this.form.get('briefingPartner')?.clearValidators();
      this.form.get('meetingDateTime')?.clearValidators();
      this.form.get('type')?.clearValidators();
      this.form.get('system')?.clearValidators();
      this.form.get('linkMeeting')?.clearValidators();
      this.form.get('partners')?.clearValidators();

      // Remover validadores de name e email para que não sejam obrigatórios na criação do evento
      this.form.get('name')?.clearValidators();
      this.form.get('email')?.clearValidators();
    }

    // Atualizar status de validação
    this.form.get('name')?.updateValueAndValidity();
    this.form.get('email')?.updateValueAndValidity();
    this.form.get('briefingCustomer')?.updateValueAndValidity();
    this.form.get('briefingSystem')?.updateValueAndValidity();
    this.form.get('briefingPartner')?.updateValueAndValidity();
    this.form.get('meetingDateTime')?.updateValueAndValidity();
    this.form.get('type')?.updateValueAndValidity();
    this.form.get('system')?.updateValueAndValidity();
    this.form.get('linkMeeting')?.updateValueAndValidity();
    this.form.get('partners')?.updateValueAndValidity();
  }

  onTypeQuestionChange(event: any): void {
    const selectedValue = event.value;
    this.updateVisibility(selectedValue);

    // Se o tipo escolhido for BRIEFING ou REUNIÃO, esvaziar o campo limit
    if (selectedValue === 'BRIEFING' || selectedValue === 'REUNIÃO') {
      this.form.get('limit')?.setValue('');
    }

    // Ajustar os validadores com base no tipo selecionado
    this.adjustFieldsRequiredByType(selectedValue);
  }

  addNewQuestion(): void {
    const newQuestion = this.form.get('newQuestion')?.value?.trim();
    if (newQuestion) {
      const controlName = `custom_${this.customQuestions.length + 1}`;

      // Adiciona a pergunta à lista
      this.customQuestions.push(newQuestion);
      this.customQuestionControls.push({
        name: newQuestion,
        controlName
      });

      // Adiciona o controle ao formulário
      this.form.addControl(controlName, this.fb.control(''));

      // Limpa o campo de entrada
      this.form.get('newQuestion')?.reset();

      console.log('Pergunta adicionada:', newQuestion);
      console.log('Perguntas personalizadas:', this.customQuestions);
    } else {
      this.toastService.showError('Digite uma pergunta válida para adicionar');
    }
  }

  removeQuestion(index: number): void {
    const controlName = this.customQuestionControls[index].controlName;
    this.customQuestions.splice(index, 1);
    this.customQuestionControls.splice(index, 1);
    this.form.removeControl(controlName);
  }

  // Método para ajustar as validações com base no tipo de evento
  adjustValidationByType(type: string): void {
    // Primeiro, restaurar o estado original de todos os campos
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      // Se o campo não é o typeQuestion (que pode estar desabilitado por design), habilite-o
      if (key !== 'typeQuestion' || !this.data?.element?.typeQuestion) {
        control?.enable();
      }
    });

    if (type === 'BRIEFING') {
      // Para BRIEFING, desabilitar campos não relevantes
      const fieldsToDisable = [
        'meetingDateTime', 'type', 'system', 'linkMeeting', 'partners',
        'partner', 'limit', 'enterprise', 'telephone', 'instagram', 'question',
        'newQuestion', 'financial', 'legal', 'consultant', 'partnerCheckbox',
        'representative', 'accounting', 'solutions', 'plans', 'dashboard', 'support',
        'name', 'email' // Adicionar name e email à lista de campos desabilitados para BRIEFING
      ];

      fieldsToDisable.forEach(field => {
        this.form.get(field)?.disable();
      });
    } else if (type === 'REUNIÃO') {
      // Para REUNIÃO, desabilitar campos não relevantes
      const fieldsToDisable = [
        'briefingCustomer', 'briefingSystem', 'briefingPartner',
        'briefingCustomerName', 'briefingSystemName', 'briefingPartnerName',
        'limit', 'enterprise', 'telephone', 'instagram', 'question',
        'newQuestion', 'financial', 'legal', 'consultant', 'partnerCheckbox',
        'representative', 'accounting', 'solutions', 'plans', 'dashboard', 'support'
      ];

      fieldsToDisable.forEach(field => {
        this.form.get(field)?.disable();
      });
    } else {
      // Para outros tipos, desabilitar campos específicos de BRIEFING e REUNIÃO
      const fieldsToDisable = [
        'meetingDateTime', 'type', 'system', 'linkMeeting', 'partners',
        'partner', 'briefingCustomer', 'briefingSystem', 'briefingPartner',
        'briefingCustomerName', 'briefingSystemName', 'briefingPartnerName'
      ];

      fieldsToDisable.forEach(field => {
        this.form.get(field)?.disable();
      });
    }
  }

  generateAndSaveForm(): void {
    // Determine o tipo de evento atual
    const eventType = this.form.get('typeQuestion')?.value ||
      (this.form.get('typeQuestion')?.disabled ? this.data?.element?.typeQuestion : '');

    // Verificação rápida se o tipo não é válido
    if (!eventType) {
      this.toastService.showError('Selecione um tipo de evento válido.');
      return;
    }

    // Se for BRIEFING, definir o campo de imagem como null
    if (eventType === 'BRIEFING') {
      this.form.get('image')?.setValue(null);
    }

    // Ajustar validação conforme o tipo de evento
    this.adjustValidationByType(eventType);

    // Verificar e exibir quais campos estão inválidos (para debug)
    const invalidFields: string[] = [];
    Object.keys(this.form.controls).forEach(key => {
      const control = this.form.get(key);
      if (control?.invalid && !control?.disabled) {
        invalidFields.push(key);
        // Marcar o campo como tocado para mostrar o erro visualmente
        control.markAsTouched();
      }
    });

    if (invalidFields.length > 0) {
      console.log('Campos inválidos:', invalidFields);
      this.toastService.showError(`Preencha todos os campos obrigatórios antes de continuar. Campos faltando: ${invalidFields.join(', ')}`);
      return;
    }

    const formValues = this.form.getRawValue(); // Obtém valores mesmo de campos desabilitados

    // Garantir que os campos de seleção (enterprise, telephone, instagram, question) estejam
    // corretamente formatados como SIM ou NÃO
    const fieldsToPrepare = ['enterprise', 'telephone', 'instagram', 'question'];
    fieldsToPrepare.forEach(field => {
      if (formValues[field] === true) {
        formValues[field] = 'SIM';
      } else if (formValues[field] === false) {
        formValues[field] = 'NÃO';
      } else if (formValues[field] && typeof formValues[field] === 'string') {
        // Se já for uma string, verificar se é 'SIM' ou outro valor
        formValues[field] = formValues[field] === 'SIM' ? 'SIM' : formValues[field];
      }
    });

    // Preparar as perguntas personalizadas (customQuestions)
    const preparedCustomQuestions = this.customQuestions.map(question => ({
      question,
      required: false,
      answer: '',
    }));

    // Preparar perguntas extras baseadas no limit e question
    const limitValue = parseInt(formValues.limit, 10) || 0;
    const extraQuestions = [];

    // Se pergunta estiver habilitada e houver um limite, criar array de perguntas extras
    if ((formValues.question === 'SIM' || formValues.question === true) && limitValue > 0) {
      for (let i = 0; i < limitValue; i++) {
        extraQuestions.push('');
      }
    }

    // Se o front só aceita 1 system e 1 partner:
    let payload = {
      ...formValues,
      typeQuestion: eventType,
      // Garantir que customQuestions seja sempre um array, mesmo que vazio
      customQuestions: preparedCustomQuestions,
      // Adicionar extraQuestions
      extraQuestions: extraQuestions,
      // Adicionar contactId SE for reunião E SE tivermos o ID
      ...(eventType === 'REUNIÃO' && this.contactIdForMeeting && { contactId: this.contactIdForMeeting })
    }

    if (eventType === 'BRIEFING') {
      // Verificar se os IDs são UUIDs válidos
      const customerId = formValues.briefingCustomer;
      const partnerId = formValues.briefingPartner;
      const systemId = formValues.briefingSystem;

      // Validar IDs antes de enviar
      if (!this.isValidUUID(customerId)) {
        this.toastService.showError('ID do cliente inválido. Selecione um cliente válido.');
        return;
      }

      if (!this.isValidUUID(partnerId)) {
        this.toastService.showError('ID do parceiro inválido. Selecione um parceiro válido.');
        return;
      }

      if (!this.isValidUUID(systemId)) {
        this.toastService.showError('ID do sistema inválido. Selecione um sistema válido.');
        return;
      }

      // Configurar payload do briefing
      payload = {
        ...payload,
        customerId: customerId,
        partnerId: partnerId,
        systemId: systemId,
        // Incluir informações de nome para referência (não serão usadas pelo backend)
        customerName: formValues.briefingCustomerName,
        partnerName: formValues.briefingPartnerName,
        systemName: formValues.briefingSystemName
      };
    } else if (eventType === 'REUNIÃO') {
      // Verificar se o sistema e parceiro têm IDs válidos
      if (
        this.systemsSelected.length === 0 ||
        !this.isValidUUID(this.systemsSelected[0].id)
      ) {
        this.toastService.showError('Selecione um sistema válido para a reunião.');
        return;
      }

      if (
        this.partnersSelected.length === 0 ||
        !this.isValidUUID(this.partnersSelected[0].id)
      ) {
        this.toastService.showError('Selecione um parceiro válido para a reunião.');
        return;
      }

      // Configurar payload da reunião
      payload = {
        ...payload,
        systemId: this.systemsSelected[0].id,
        partnerId: this.partnersSelected[0].id,
        meeting: {
          meetingDateTime: formValues.meetingDateTime,
          type: formValues.type,
          linkMeeting: formValues.linkMeeting,
        },
      };
    }

    console.log('Dados do formulário a serem enviados (com contactId se reunião):', payload);

    // Desabilitar o botão de envio para evitar submissões duplicadas
    this.form.disable();

    if (this.data.type === TypeCesEnum.EDIT && this.data.element?.id) {
      // Edição de evento existente
      this.eventsService.update(this.data.element.id, payload).subscribe({
        next: (updatedEvent) => {
          this.dialogRef.close({ element: updatedEvent });
          this.toastService.showSuccess('Evento atualizado com sucesso!');
        },
        error: (error) => {
          console.error('Erro ao atualizar evento:', error);
          this.toastService.showError('Erro ao atualizar evento: ' + (error.error?.message || 'Verifique os dados informados.'));
          this.form.enable(); // Reabilitar o formulário em caso de erro
        },
      });
    } else {
      // Criação de novo evento
      this.eventsService.createEvent(payload).subscribe({
        next: (createdEvent) => {
          this.dialogRef.close({ element: createdEvent });
        },
        error: (error) => {
          this.toastService.showError('Erro ao criar agendamento: ' + (error.error?.message || 'Verifique os dados informados.'));
          this.form.enable(); // Reabilitar o formulário em caso de erro
        },
      });
    }
  }

  getCurrentPartnerId(): string | null {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.partner?.id || null;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  // Adicionar um método para validar UUIDs
  isValidUUID(uuid: string): boolean {
    const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;
    return regexExp.test(uuid);
  }

  // Adicionar função para atualizar o filtro de sistemas com base no tipo selecionado
  onSystemTypeChange(event: any): void {
    // Obtém o valor do tipo de sistema selecionado
    const selectedType = event.value;

    console.log('Tipo selecionado:', selectedType, typeof selectedType);

    // Converter o valor do tipo (ex: "SISTEMA") para o ID correspondente no SystemTypeIdEnum
    const typeId = SystemTypeIdEnum[selectedType as keyof typeof SystemTypeIdEnum];

    console.log('ID do tipo:', typeId, typeof typeId);

    // Referência ao campo system no formulário para obter o componente
    const systemConfig = this.getFieldConfig('system');

    // Se o campo system tiver uma referência ao componente, atualizar o filtro
    if (systemConfig && systemConfig.component) {
      // Atualiza os dados do componente com o novo tipo
      if (!systemConfig.componentData) {
        systemConfig.componentData = { params: {} };
      }

      systemConfig.componentData.params = {
        ...systemConfig.componentData.params,
        type: typeId
      };

      console.log('Nova configuração do componente system:', systemConfig.componentData);

      // Reset do valor do campo sistema para evitar inconsistências
      this.form.get('system')?.setValue('');
      this.systemsSelected = [];

      console.log(`Tipo de sistema filtrado: ${selectedType} (ID: ${typeId})`);
    } else {
      console.error('systemConfig ou systemConfig.component não definido:', systemConfig);
    }
  }

  // Método chamado antes de abrir o seletor de sistema
  beforeSystemSelect(): void {
    // Obter o tipo de sistema selecionado
    const selectedType = this.form.get('type')?.value;

    if (selectedType) {
      // Converter para ID
      const typeId = SystemTypeIdEnum[selectedType as keyof typeof SystemTypeIdEnum];

      // Atualizar a configuração do componente de sistema
      const systemConfig = this.getFieldConfig('system');

      if (systemConfig && systemConfig.componentData) {
        systemConfig.componentData.params = {
          ...systemConfig.componentData.params,
          type: typeId
        };

        console.log('Configuração do componente de sistema atualizada:', systemConfig.componentData);
      }
    }
  }

  // Método para forçar a atualização dos inputs de reunião
  forceUpdateMeetingInputs(): void {
    console.log('Forçando atualização dos inputs de reunião...');

    // Obter referências aos campos
    const typeInput = this.getFieldConfig('type');
    const systemInput = this.getFieldConfig('system');
    const partnersInput = this.getFieldConfig('partners');

    // Forçar atualização
    setTimeout(() => {
      // Verificar valores atuais
      console.log('Valores atuais dos campos: ', {
        type: this.form.get('type')?.value,
        system: this.form.get('system')?.value,
        partners: this.form.get('partners')?.value
      });

      // Forçar evento de change para o Angular detectar
      this.form.get('type')?.updateValueAndValidity();
      this.form.get('system')?.updateValueAndValidity();
      this.form.get('partners')?.updateValueAndValidity();

      // Atualizar a referência na tela
      this.cdr.detectChanges();
      this.cdr.markForCheck();
    }, 100);
  }
}
